import { LitElement, type PropertyValues } from 'lit';
import {  property, state } from 'lit/decorators.js';
import { query } from 'lit/decorators/query.js';


export class CanvaPageBase extends LitElement {
  // Properties declaration using decorators
  @property({ type: String })
  declare someProperty: string; // Replace with your actual properties

  @state()
  private declare internalState: any; // Replace with your actual state

  @query('#top')
  private declare topElement: HTMLElement;

  constructor() {
    super();
    // Initialize properties if needed
    this.someProperty = '';
  }



  protected override updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);
    // Code that runs after updates
  }

  // Async method to compute top element
  async _computeTop(): Promise<HTMLElement | null> {
    await this.updateComplete;
    return this.topElement;
  }

 
  // Optional: Define styles if needed
  // static override styles = css`...`;
}